import { useEffect, useState } from "react";
import { Header } from "../../components/Header";
import { HeaderCategories } from "../../components/HeaderCategories";
import { Menu } from "../../components/Menu";
import { PDVItem } from "../../components/PDVItem";
import {
  useParams,
  useSearchParams,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import api from "../../services/api";
import "./index.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import { HeaderMultCategories } from "../../components/HeaderMultCategories";
import ReactLoading from "react-loading";
import { useCategory } from "../../hooks/useCategory";
import {
  ProductType,
  ProductsReturnType,
} from "../../contexts/ProductsContext";
import { SimpleCategoryType } from "../../contexts/CategoryContext";
import { useProduct } from "../../hooks/useProduct";
import { useScroll } from "../../hooks/useScroll";
import { SellerBanner } from "../../components/SellerBanner/sellerBanner";
import { useOrder } from "../../hooks/useOrder";
import EmptyState from "../../components/EmptyStates/EmptyState";
import { OrdenacaoProdutos } from "../../components/OrdernacaoProdutos/OrdenacaoProdutos";
import { FiltroPdvModal } from "../../components/FiltroProdutos/FiltroProdutos";

import { IoOptions } from "react-icons/io5";
import { IoSwapVertical } from "react-icons/io5";
import IconesNovos from "../../components/NewIcones/IconesNovos";


export function PDV() {
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();
  const { category_id } = useParams();
  const { search } = useLocation();
  const { getAppConfig, blockLayoutInProduct, saveBlockLayoutInProduct } = useAppConfig();
  const { getSellerInfo } = useOrder();
  const { getToken, registerAccess, getThisPluginspace, getLocations, } =
    usePluginspace();
  const { setCurrentPage, saveOrderByForPage, getOrderByForPage } = useProduct();
  const {
    getSubcategorySelected,
    getChildrenCategories,
    subcategoryToAgroup,
    setSubcategoryToAgroup,
    getCategoriesAll
  } = useCategory();
  const { getProducts, setOpenModalFiltroPDV } = useProduct();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [request, setRequest] = useState(false);
  const [subcategory, setSubcategory] = useState<SimpleCategoryType | null>(
    null
  );

  const [subcategoryName, setSubcategoryName] = useState<string | null>(null);


  const [products, setProducts] = useState<Array<ProductType>>([]);
  const [page, setPage] = useState(1);
  const [subcategories, setSubcategories] = useState<Array<SimpleCategoryType>>(
    []
  );
  const [agroupCategory, setAgroupCategory] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(true);
  const { scrollYProduct, setScrollYProduct } = useScroll();
  const [loadingHeader, setLoadingHeader] = useState(true);

  const [isDown, setIsDown] = useState(false);
  const [nameSearch, setNameSearch] = useState("");


  const [openModalFiltro, setOpenModalFiltro] = useState(false);
  const [imagemVertical, setImagemVertical] = useState(false);

  const [metaPage, setMetaPage] = useState<{
    hasNextPage: boolean
    hasPreviousPage: boolean
    itemCount: number
    page: string
    pageCount: number
    take: string
  } | null>();

  const orderBy = getOrderByForPage('pdv', category_id);


  useEffect(() => {
    async function init() {
      registerAccess("pdv");
      await getConfig();

    }
    init();
  }, []);

  // Ao entrar na página pdv


  // Ao salvar orderBy na página pdv

  // Ao obter orderBy da página pdv

  async function loadingProducts() {
    const categorie = await getSubcategory();
    await loadProducts(
      [],
      "",
      1,
      categorie
        ? categorie
        : subcategoryToAgroup
          ? subcategoryToAgroup
          : undefined
    );
    await getSubcategory()
  }

  useEffect(() => {
    setCurrentPage('pdv', category_id);
    setPage(1);
    setProducts([]);
    if (subcategoryToAgroup) {
      setSubcategory(subcategoryToAgroup);
      setPage(1);
    }
    if (search) {
      const [typeSearch, name] = search.split("=");
      try {
        const nameDecoded = window.atob(name) ? window.atob(name) : "";
        setNameSearch(nameDecoded);
        if (typeSearch === "?catalog") {
          getProductsCatalog([], name, 1);
        } else {
          loadProducts(
            [],
            nameDecoded,
            1,
            subcategoryToAgroup ? subcategoryToAgroup : undefined
          );
        }
      } catch (e) {
        console.log(e);
        const nameDecoded = name;
        setNameSearch(nameDecoded);
        if (typeSearch === "?catalog") {
          getProductsCatalog([], nameDecoded, 1);
        } else {
          loadProducts(
            [],
            nameDecoded,
            1,
            subcategoryToAgroup ? subcategoryToAgroup : undefined
          );
        }
      }
    } else {
      loadingProducts();
    }
  }, [category_id, search]);


  async function loadCategoriaName() {
    if (category_id) {
      const allCategories = await getCategoriesAll();
      let currentCategory = allCategories.find((cat: SimpleCategoryType) => parseInt(cat.id.toString()) === parseInt(category_id));
      let categoryPath: string[] = [];
      while (currentCategory) {
        categoryPath.unshift(currentCategory.name);
        if (!currentCategory.parent) break;
        currentCategory = allCategories.find((cat: SimpleCategoryType) => cat.code === currentCategory?.parent);
      }
      setSubcategoryName(categoryPath.join(" > "));
    }
  }




  async function getSubcategory() {
    if (category_id) {
      const newSub = await getSubcategorySelected(category_id);
      setSubcategory(subcategoryToAgroup ? subcategoryToAgroup : newSub);
      await loadCategoriaName();





      return newSub;
    }
    return null;
  }

  async function getProductsCatalog(
    newProducts: ProductType[] = [],
    search: string = "",
    page = 1
  ) {
    const configProject: ConfigType | void = await getAppConfig();
    if (newProducts.length === 0) {
      setLoading(true);
    }
    await api
      .get(`api/catalog/${search}`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const productsIds = response.data.data[0].products.map(
          (product: ProductType) => product.id
        );
        await api
          .post(
            `api/product/newFilter_v2?page=${page}&take=${configProject?.content.qtdProductsPagination
              ? configProject.content.qtdProductsPagination
              : 10
            }`,
            {
              productsIds,
              status: true,
              isPriceGreaterThan: 0,
              isInventoryGreaterThan:
                configProject && configProject.content.pdv.showOutStock ? 0 : 1,
              variationActive: true,
              validClassification: true,
              //locationId: location?.id ? location.id : "",
            },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            }
          )
          .then(async (response) => {
            setHasNextPage(response.data.meta.hasNextPage);
            response.data.data.map((product: ProductType) => {
              if (
                product.variations[0] &&
                product.variations[0].img &&
                !product.variations[0].img.includes("http")
              ) {
                product.variations[0].img = `https://s3.amazonaws.com/img.ninegrid.com/${product.variations[0].img}`;
              }
              product.images = product.images.map((image) => {
                let imgProduct =
                  image.path.split("://")[1] ===
                    "s3.amazonaws.com/img.ninegrid.com"
                    ? image.path + "/" + image.imgsuffix
                    : image.path;

                image.imgsuffix = imgProduct;
                return image;
              });
              newProducts.push(product);
            });
            const productsAdd = newProducts
              .filter(
                (product) =>
                  product.variations.length > 0 &&
                  parseInt(product.classificationId) > 0 &&
                  product.type !== "optional" &&
                  !product.sellAsFractional
              )
            setProducts(productsAdd);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
    scrollToBefore();
  }

  async function loadProducts(
    newProducts: ProductType[] = [],
    search: string = "",
    page = 1,
    newSubcategory?: SimpleCategoryType
  ) {
    setIsLoading(true);
    const configProject: ConfigType | void = await getAppConfig();
    if (newProducts.length === 0) {
      setLoading(true);
    }
    let newAgroup = false;
    let showOutStock =
      configProject &&
      configProject.content &&
      configProject.content.pdv &&
      configProject.content.pdv.showOutStock;
    let qtdProductsPagination =
      configProject &&
        configProject.content &&
        configProject.content.qtdProductsPagination
        ? configProject.content.qtdProductsPagination
        : 10;
    if (
      configProject &&
      configProject.content &&
      configProject.content.pdv &&
      configProject.content.pdv.agroupCategory &&
      category_id
    ) {
      setAgroupCategory(
        configProject.content.pdv.agroupCategory && search === ""
      );
      newAgroup = configProject.content.pdv.agroupCategory && search === "";
      const newSubs = await getChildrenCategories(category_id);
      setSubcategories(newSubs);
    }

    const pluginSpaceInfo = await getThisPluginspace();
    if (pluginSpaceInfo) {
      const productReturn: ProductsReturnType = await getProducts(
        pluginSpaceInfo,
        newProducts,
        search,
        page,
        newAgroup,
        category_id ? parseInt(category_id) : 0,
        showOutStock ? showOutStock : false,
        newSubcategory ? newSubcategory : subcategory ? subcategory : undefined,
        qtdProductsPagination,
        orderBy
      );
      setProducts(productReturn.products);
      setHasNextPage(productReturn.hasNextPage);
      setMetaPage(productReturn.meta ? productReturn.meta : null);
    }
    setIsLoading(false);
    setLoading(false);
    setRequest(false);
    //setSubcategory(null);
    scrollToBefore();
  }

  async function getConfig() {
    setLoadingHeader(true);
    await getSellerInfo();
    const config = await getAppConfig();

    if (config) {
      setImagemVertical(config.content.typeImage !== "square");
    }

    setConfig(await getAppConfig());
    setLoadingHeader(false);
  }

  function goTop() {
    const divItem = document.getElementById("content-pdv");
    if (divItem) {
      divItem.scroll({ behavior: "smooth", top: 0 });
    }
  }

  function checkBottom(event: any) {
    saveScroll(event);

    if (event.target.scrollTop > 0) setIsDown(true);
    else setIsDown(false);

    const bottom =
      event.target.scrollHeight -
      event.target.scrollTop -
      event.target.clientHeight <=
      50;


    if (bottom && !request) {
      if (!hasNextPage) return;
      const newPage = page + 1;
      setPage(newPage);

      setRequest(true);

      if (search) {
        const [typeSearch, name] = search.split("=");

        if (typeSearch === "?catalog") {
          getProductsCatalog(Object.assign(products), name, newPage);
        } else {
          loadProducts(Object.assign(products), window.atob(name), newPage);
        }
      } else {
        loadProducts(Object.assign(products), "", newPage);
      }
    }
  }

  async function getProductsAgroup(newSubcategory: SimpleCategoryType) {
    setSubcategoryToAgroup(newSubcategory);
    setSubcategory(newSubcategory);
    setPage(1);
    let nameToSearch = "";
    if (search) {
      const [, name] = search.split("=");
      nameToSearch = name ? name : "";
    }
    await loadProducts([], nameToSearch, 1, newSubcategory);
  }

  const saveScroll = (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
    setScrollYProduct({
      id: event.currentTarget.id,
      position: event.currentTarget.scrollTop,
    });
  };

  const scrollToBefore = () => {
    if (scrollYProduct.id) {
      const divItem = document.getElementById(scrollYProduct.id);
      if (divItem) divItem.scrollTop = scrollYProduct.position;
    }
  };


  useEffect(() => {
    loadProducts()
  }, [orderBy])

  return (
    <div className="pdv">
      <div
        className="content-pdv"
        id="content-pdv"
        onScroll={(e: any) => checkBottom(e)}
      >
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
            extraSpacingLeftMenu
          />
        )}
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <>
            {agroupCategory ? (
              <HeaderMultCategories
                fontColor={
                  config?.webappcolor.fonttitlebar
                    ? config.webappcolor.fonttitlebar
                    : "#FFFFFF"
                }
                backgroundColor={
                  config?.webappcolor.backgroundtitlebar
                    ? config.webappcolor.backgroundtitlebar
                    : "#000000"
                }
                categories={
                  subcategories.length > 0 && category_id && !search
                    ? subcategories
                    : []
                }
                categoryId={subcategory?.id ? subcategory?.id : 0}
                clickSubcategory={getProductsAgroup}
              />
            ) : (
              <HeaderCategories
                fontColor={
                  config?.webappcolor.fonttitlebar
                    ? config.webappcolor.fonttitlebar
                    : "#FFFFFF"
                }
                backgroundColor={
                  config?.webappcolor.backgroundtitlebar
                    ? config.webappcolor.backgroundtitlebar
                    : "#000000"
                }
                categories={
                  category_id
                    ? [subcategory?.name ? subcategory.name : ""]
                    : ["PESQUISA"]
                }
                blockViewMode={
                  config && config.content.noUseViewMode
                    ? config.content.noUseViewMode
                    : false
                }
                inBlocks={blockLayoutInProduct}
                setInBlocks={saveBlockLayoutInProduct}
              />
            )}

            <>
              <div
                onClick={() => goTop()}
                className="pdv-arrow-top"
                style={
                  isDown
                    ? {
                      visibility: "inherit",
                      border: `1px solid ${config?.webappcolor.backgroundtitlebar
                        ? config.webappcolor.backgroundtitlebar
                        : "#EAEAEA"
                        }`,
                    }
                    : {
                      visibility: "hidden",
                    }
                }
              >
                <i
                  style={{
                    color: `${config?.webappcolor.backgroundtitlebar
                      ? config.webappcolor.backgroundtitlebar
                      : "#EAEAEA"
                      }`,
                  }}
                  className="fa fa-arrow-up"
                ></i>
              </div>
              <div style={{
                marginTop: "88px",
                width: "100%",
                overflow: "auto",
                height: "100%",
                gap: "16px",
                display: "flex",
                flexDirection: "column",
                padding: "16px 0",
              }}>

                {/*Novo baner do vendedor caso o cliente recebeu o link dele */}
                <SellerBanner marginTop="0rem" />

                {/*Componentes para Filtro */}
                <div style={{ display: "flex", gap: "0.5rem", padding: "0 1rem" }}>
                  <OrdenacaoProdutos orderBy={orderBy} onSelectOrderBy={(value: string) => {
                    saveOrderByForPage('pdv', value, category_id);
                  }} />
                  <button className="button_modal_teste_12u3y12ashj" onClick={() => setOpenModalFiltroPDV(true)}>
                    <IconesNovos cor={"#636363"}
                      active={true} type={'filter_small'} action={() => null} />
                    Filtrar </button>
                </div>

                <div className={`info_container_12897uif79 `}>
                  {metaPage && <span><b> {metaPage.itemCount} </b> PRODUTOS</span>
                  }            <span><b> Você está em:</b> {subcategoryName} </span>
                </div>

                {products.length === 0 ? (
                  <div className={'empty_state_jhkaldsjhasd'}>

                    <EmptyState type={search ? 'search' : 'product'} textButton={"Voltar"} colorIcon={config?.webappcolor.iconsheader
                      ? config.webappcolor.iconsheader
                      : "#CEA127"}
                      action={() => navigate(-1)}
                      noShowBackground
                    />
                  </div>

                ) : (
                  <>
                    {/*Continuação do fluxo */}
                    <div
                      className={blockLayoutInProduct ? "items-pdv" : "items-pdv-list"}
                      style={{
                        marginBottom: isLoading ? "6rem" : "",
                        boxSizing: "border-box",
                        width: "100%",
                      }}
                    >
                      {products.map((product) => {
                        if (product.variations.length > 0) {

                          let useImagePlaceholder = false;
                          let productImg = product.images.find(
                            (image) => image.typeimg === "imgsmall"
                          )?.imgsuffix;
                          if (!productImg) {
                            productImg = "/imagem/produto-sem-imagem.png";
                            useImagePlaceholder = true;
                          }
                          return (
                            <PDVItem
                              id={product.id}
                              type={product.type}
                              name={product.name}
                              stock={!!product.variations.find(e => e.inventory > 0)?.inventory}
                              mark={product.mark ? product.mark.name : "-/-"}
                              reference_id={product.code}
                              price={product.variations[0].price}
                              promotionalPrice={
                                product.variations[0].promotionalPrice
                              }
                              image={productImg ? productImg : ""}
                              inBlocks={blockLayoutInProduct}
                              description={product.description}
                              key={product.id}
                              fontColor={"#636363"}
                              food={
                                config?.template === "food" ||
                                config?.template === "retail"
                              }
                              noImage={
                                config?.content.pdv.noProductImages
                                  ? config?.content.pdv.noProductImages
                                  : false
                              }
                              discountCoupon={{
                                color: config?.webappcolor.flagDiscountColor
                                  ? config.webappcolor.flagDiscountColor
                                  : "#000",
                                type: config?.content.flagDiscount
                                  ? config?.content.flagDiscount
                                  : "trigonal",
                              }}
                              isVertical={imagemVertical}
                            />
                          );
                        }
                      })}

                    </div>
                  </>)}
              </div>
            </>

          </>
        )}
        {isLoading && !loading && (
          <div style={{ marginTop: -130 }}>
            <ReactLoading type={"bubbles"} color={"#b5b5b5"} height={20} />
          </div>
        )}
        {!loadingHeader && (
          <Menu
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
      <FiltroPdvModal />
    </div >
  );
}
